import { ApiResponseBodyCell } from "components/UI/Table/UI/ApiResponseBodyCell/ApiResponseBodyCell";
import { EmptyCell } from "components/UI/Table/UI/EmptyCell/EmptyCell";
import { FC } from "react";

const START_STEP_TYPES = ["integration", "incoming_postback", "outgoing_postback", "structure"];

interface StepLogMessageCellProps {
    message: string | null | undefined;
    stepType?: string | null;
    id: string;
    lines?: number;
}

export const StepLogMessageCell: FC<StepLogMessageCellProps> = ({ message, stepType, id, lines }) => {
    if (stepType !== undefined && (!stepType || START_STEP_TYPES.includes(stepType))) return <EmptyCell />;
    if (!message) return <EmptyCell />;

    let body: unknown = message;
    try {
        body = JSON.parse(message);
    } catch {
        const msgLines = message.split("\n").filter(Boolean);
        const isKeyValue = msgLines.every((line) => line.includes(" => "));
        if (isKeyValue) {
            body = Object.fromEntries(
                msgLines.map((line) => {
                    const sep = line.indexOf(" => ");
                    return [line.slice(0, sep), line.slice(sep + 4)];
                })
            );
        }
    }

    return <ApiResponseBodyCell response={{ body }} id={id} lines={lines} />;
};
